import { render, staticRenderFns } from "./Machines.vue?vue&type=template&id=badf1d74&scoped=true"
import script from "./Machines.vue?vue&type=script&lang=ts"
export * from "./Machines.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf1d74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('badf1d74')) {
      api.createRecord('badf1d74', component.options)
    } else {
      api.reload('badf1d74', component.options)
    }
    module.hot.accept("./Machines.vue?vue&type=template&id=badf1d74&scoped=true", function () {
      api.rerender('badf1d74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Machines.vue"
export default component.exports